export default "__VITE_ASSET__qq0HNZi9__"